import { render, staticRenderFns } from "./modal-debug.vue?vue&type=template&id=4606400f&scoped=true&"
import script from "./modal-debug.vue?vue&type=script&lang=js&"
export * from "./modal-debug.vue?vue&type=script&lang=js&"
import style0 from "./modal-debug.vue?vue&type=style&index=0&id=4606400f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4606400f",
  null
  
)

export default component.exports